import { ReactElement } from "react";

import { getTranslation } from "../../../common/helpers/getStaticProps";
import { ServerSideContext } from "../../../common/types/app";

import { RegisterLayout } from "@/features/Auth/Register/layouts/RegisterLayout";
import { SignUpMethodChoiceStep } from "@/features/Auth/Register/Steps/SignUpMethodChoice/SignUpMethodChoiceStep";

const RegisterReferralMethodChoice = () => {
  return <SignUpMethodChoiceStep />;
};

RegisterReferralMethodChoice.getLayout = (page: ReactElement) => (
  <RegisterLayout currentStep="method-choice" isReferral>
    {page}
  </RegisterLayout>
);

export const getStaticProps = async (context: ServerSideContext<null>) => {
  return {
    props: await getTranslation(context.locale, ["common", "register"]),
  };
};

export default RegisterReferralMethodChoice;
